export function usePaymentPermissions() {
  const { permissions } = storeToRefs(useAuthStore());
  const route = useRoute();

  const routeName = computed(() => {
    return route?.name?.replaceAll("-", "_");
  });
  const canOneClickProcessEdit = computed(() => {
    const currentRoute = routeName.value;

    return permissions.value[currentRoute]?.["1_click_process_edit"];
  });

  return {
    canOneClickProcessEdit,
  };
}
